import Vue from "vue"

export default {
  setOpenBy(state, payload) {
    Vue.set(state.openBy, payload.route, payload.openBy)
  },
  setCount(state, payload) {
    Vue.set(state.count, payload.list, payload.count)
  },
  setUserDashboard(state, payload) {
    Vue.set(state, "userDashboard", payload)
  },
  setAnonStatus(state, payload) {
    Vue.set(state.anonStatus, payload.id, payload.msg)
  },
  setAnalyzeProgress(state, payload) {
    Vue.set(state.analyzeProgress, payload.document, payload.analyzeProgress)
  },
  setCorrectionProgress(state, payload) {
    Vue.set(
      state.correctionProgress,
      payload.opinion,
      payload.correctionProgress
    )
  },
  setLastListsPayload(state, payload) {
    state.lastListsPayload = payload
  }
}
